import React, { useEffect } from "react";
import { NavigateFunction, Params } from "react-router-dom";
import MerchantAccountSignUp from "./MerchantAccountSignUp";
import MerchantAccountStore from "../MerchantAccountStore";
import {
  CountryStore,
  ItemsStore,
  RolesAndPermissionStore,
} from "../../../shared/store";
import NMIMerchantAccountSignUp from "./NMIMerchantAccountSignUp";
import { withRouter } from "@mindmemobile/mm-shared-global";
type IProps = {
  navigate: NavigateFunction;
  merchantAccountStore: MerchantAccountStore;
  itemStore: ItemsStore;
  rolesAndPermissionStore: RolesAndPermissionStore; 
  params: Readonly<Params<string>>;
};

const MerchantSignup: React.FC<IProps> = ({
  params,
  navigate,
  merchantAccountStore,
  itemStore,
  rolesAndPermissionStore, 
}) => {
  const gateway = getGateway();

  function getGateway() {
    return params.gateway;
  }
  // useEffect(() => {
  //     if (gateway !== 'Fiserv' && gateway !== 'NMI') {
  //         navigate('/app/merchant-accounts/choose-gateway');
  //     }
  // }, [gateway, navigate]);

  switch (gateway) {
    case "Fiserv":
      return (
        <MerchantAccountSignUp 
          merchantAccountStore={merchantAccountStore}
          rolesAndPermissionStore={rolesAndPermissionStore}
          itemStore={itemStore}
        />
      );
    case "NMI":
      return (
        <NMIMerchantAccountSignUp 
          merchantAccountStore={merchantAccountStore}
          rolesAndPermissionStore={rolesAndPermissionStore}
          itemStore={itemStore}
        />
      );
    default:
      return null;
  }
};

export default withRouter(MerchantSignup);
